let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("107zu"), load("cHTTI"), load("hhss7"), load("aoU9B")]).then(() => parcelRequire('a6OFr'));